// extracted by mini-css-extract-plugin
module.exports = {"title":"toggle_title__2xQfx","active":"toggle_active__2CV-D","container":"toggle_container__L37J0","text":"toggle_text__1h8dq","wrapper":"toggle_wrapper__3Z5eo"};